(() => {
  function initRitual(section) {
    if (!section) return;

    const isPopupMode = section.getAttribute('data-popup-mode') === 'true';
    if (!isPopupMode) return;

    const panel = section.querySelector('[data-mali-complete-ritual]');
    const closeButton = section.querySelector('[data-mali-ritual-close]');
    const tabButton = section.querySelector('[data-mali-ritual-tab]');
    const openDelay = parseInt(section.getAttribute('data-open-delay') || '5000', 10);

    if (!panel || !closeButton || !tabButton) return;

    section.classList.add('is-hidden-before-open');

    const reveal = () => {
      section.classList.remove('is-hidden-before-open');
      section.classList.add('is-open');
      section.classList.remove('is-minimized');
      section.classList.remove('is-minimizing');
    };

    const minimize = () => {
      section.classList.add('is-minimizing');
      section.classList.remove('is-open');

      window.setTimeout(() => {
        section.classList.remove('is-minimizing');
        section.classList.add('is-minimized');
      }, 360);
    };

    window.setTimeout(reveal, Number.isFinite(openDelay) ? openDelay : 5000);

    closeButton.addEventListener('click', minimize);
    tabButton.addEventListener('click', reveal);
  }

  function init() {
    document.querySelectorAll('[data-mali-ritual]').forEach(initRitual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

